import React, {useState}  from 'react';
import {
  Card,
  CardBody,CardHeader, CardTitle, Table, 
  Modal,
  ModalBody,
 } from "reactstrap";
import { Spinner } from 'components/Icons/Spinner';
import { Link } from 'react-router-dom';
import { TutorEnrollCard } from './TutorEnrollCard';
import { useSelector } from 'react-redux'
var Utils = require ('Utils');
var Const = require ('Const');
var Icons = require ('Icons');

const TutorListCard = ( { personas, isLoading,enroleTutor,unEnroleTutor, topLevel  } ) =>  {

  const [modalOpen, setModalOpen] = useState(false);
  
  const { course, token } = useSelector(state => ({
    token: state.auth.session.jwt_token, 
    course: state.courses.course
    
   }))

    return (
          <>
          <Modal toggle={() => setModalOpen(!modalOpen)} isOpen={modalOpen}  size="lg">
            <ModalBody >
                  <TutorEnrollCard 
                    topLevel={topLevel}
                    enroleTutor={enroleTutor}
                    closeMe={setModalOpen}
                    currentTutors={personas.map( tutor => tutor.persona_id)}
                  />
            </ModalBody>
        </Modal>
  
          {(personas && !isLoading) ?
            <Card className="card-tasks">
               <CardHeader>
                  <CardTitle tag="h4">{(topLevel&& (topLevel==='PRIM' || topLevel==='KIN' )?'Docentes Titulares':'Preceptores')} 
                        <div className="float-right">
                          <Link to="#"
                            onClick={() => { setModalOpen(!modalOpen)  }}
                          >
                            <i className={Icons.PERSON_ADD} />
                          </Link>
                        </div>
                  </CardTitle>
               </CardHeader>
               <CardBody>
                   <Table className="table table-striped mb-0" >
                     <tbody>
                    { personas.map( ( persona, idx ) => { 
                      return (
                         <tr key={persona.persona_id}>
                            <td className="img-row">
                              <div className="img-wrapper">
                                <img
                                  alt="..."
                                  className="img-raised"
                                  src={persona.image?persona.image:Const.DEFAULT_IMAGE_PROFILE[(persona.gender?persona.gender:'O')]}
                                />
                              </div>
                            </td>
                            <td className="text-left">
                                {Utils.capitalize(persona.last_name + ", " + persona.name)}
                            </td>
                            <td >
                              <Link to="#"
                                onClick={() => { unEnroleTutor(token, course.course_id,persona.persona_id) }}
                              >
                              <i className={Icons.REMOVE} />
                            </Link>
                            </td>
                          </tr>

                         
                          )
                      } ) }

                      </tbody>

                  </Table>
                  </CardBody>
            </Card>                   
          :
          <Spinner size="XL" />
          }
        </>
  
        );
        }

export { TutorListCard } ;
